import { useEffect, useState } from 'react'

/**
 * The settled value of a text filter.
 *
 * Every ledger list puts its filters straight into the query key, which is what makes a filtered
 * view a cached view. A free-text field wired to that directly would issue one request per
 * keystroke — eight requests to type an account code, seven of which are answered and discarded, on
 * an endpoint that reads the journal table.
 *
 * The delay is the same 300ms the customer list uses: long enough that a code typed at speed is one
 * request, short enough that the result feels like it followed the typing.
 */
const DEFAULT_DELAY_MS = 300

export function useDebounced<T>(value: T, delayMs: number = DEFAULT_DELAY_MS): T {
  const [settled, setSettled] = useState(value)

  useEffect(() => {
    const timer = window.setTimeout(() => setSettled(value), delayMs)

    return () => {
      window.clearTimeout(timer)
    }
  }, [value, delayMs])

  return settled
}
